<template>
  <div class="content">
    <p>{{ $t('personalDescriptions.title') }}</p>
    <base-button @click="navigateNextPage('Teacher')">{{
      $t('personalDescriptions.teacher')
    }}</base-button>
    <base-button @click="navigateNextPage('Librarian')">{{
      $t('personalDescriptions.librarian')
    }}</base-button>
    <base-button @click="navigateNextPage('Purchaser')">{{
      $t('personalDescriptions.purchaser')
    }}</base-button>
    <base-button @click="navigateNextPage('Other')">{{
      $t('personalDescriptions.other')
    }}</base-button>
  </div>
  <div class="pagenumber">
    <label>4/7</label>
  </div>
</template>

<script>
export default {
  data() {
    this.$store.state.profession = '';
    return;
  },
  methods: {
    navigateNextPage(data) {
      this.$store.state.profession = data;
      this.$router.push('/sendinformation');
    },
  },
};
</script>

<style>
div.content {
  width: 1000px;
}
</style>
